<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 9.25L10 4.75M10 4.75L5.5 9.25M10 4.75L10 13.75"
      stroke="#666666"
      stroke-width="1.5"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M4.75 16.75L15.25 16.75"
      stroke="#666666"
      stroke-width="1.5"
      stroke-linecap="round"
      class="stroke"
    />
  </svg>
</template>

<style lang="scss" scoped>
svg .stroke {
  stroke: #df252a;
}

svg .fill {
  fill: #df252a;
}
</style>
